import { AnyType } from '@core/types'

export type ClassDefinition = new (...args: AnyType[]) => AnyType

export type ClassConstructorReturnType<T> = T extends new (...args: AnyType[]) => infer R ? R : AnyType

export function isClassDefinition(value: AnyType): value is ClassDefinition {
	return typeof value === 'function'
}
